import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {environment} from 'environments/environment';
import {AuthGuardWithForcedLogin} from './core/auth-guard-with-forced-login.service';

const appRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardWithForcedLogin],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'advisor-commision',
                loadChildren: () => import('app/main/advisor-commision/advisor-commision.module').then(m => m.AdvisorCommisionModule)
            },
            {
                path: 'advisor-detail',
                loadChildren: () => import('./main/advisor-detail/advisor-detail.module').then(m => m.AdvisorDetailModule)
            },
            {
                path: 'advisor-list',
                loadChildren: () => import('./main/advisor-list/advisor-list.module').then(m => m.AdvisorListModule)
            },
            {
                path: 'advisor-tree',
                loadChildren: () => import('./main/advisor-tree/advisor-tree.module').then(m => m.AdvisorTreeModule)
            },
            {
                path: 'client-detail',
                loadChildren: () => import('./main/client-detail/client-detail.module').then(m => m.ClientDetailModule)
            },
            {
                path: 'client-list',
                loadChildren: () => import('./main/client-list/client-list.module').then(m => m.ClientListModule)
            },
            {
                path: 'contract-create',
                loadChildren: () => import('./main/contract-create/contract-create.module').then(m => m.ContractCreateModule)
            },
            {
                path: 'contract-detail',
                loadChildren: () => import('./main/contract-detail/contract-detail.module').then(m => m.ContractDetailModule)
            },
            {
                path: 'contract-list',
                loadChildren: () => import('./main/contract-list/contract-list.module').then(m => m.ContractListModule)
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule)
            },
            {
                path: 'dev-form',
                loadChildren: () => import('./main/dev-form/dev-form.module').then(m => m.DevFormModule)
            },
            {
                path: 'manufactory-list',
                loadChildren: () => import('./main/manufactory-list/manufactory-list.module').then(m => m.ManufactoryListModule)
            },
            {
                path: 'profile',
                loadChildren: () => import('./main/profile/profile.module').then(m => m.ProfileModule)
            },
            {
                path: 'reports-advisors',
                loadChildren: () => import('./main/reports-advisors/reports-advisors.module').then(m => m.ReportsAdvisorsModule)
            },
            {
                path: 'reports-hq',
                loadChildren: () => import('./main/reports-hq/reports-hq.module').then(m => m.ReportsHqModule)
            },
            {
                path: 'applicants-list',
                loadChildren: () => import('./main/applicants-list/applicants-list.module').then(m => m.ApplicantsListModule)
            },
            {
                path: '**',
                redirectTo: '/dashboard',
                pathMatch: 'full'
            },
        ]
    }
];

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forRoot(appRoutes, {enableTracing: !environment.production, onSameUrlNavigation: 'reload'}),
    ],
    exports: [
        RouterModule,
    ]
})

export class AppRoutingModule {
}
